module.exports = __webpack_public_path__ + "img/back-blue.87513d5e.svg";